import React, { memo } from 'react'

import { node, string } from 'prop-types'

import DesktopOnlyTooltip from 'Pods/Shared/DesktopOnlyTooltip/DesktopOnlyTooltip'

function ToolTooltip({ id, label, children }) {
  return (
    <DesktopOnlyTooltip
      id={id}
      content={label}
      place="top"
      containerClass="image-assistant-edit-tab__tool-tooltip"
      className="image-assistant-edit-tab__tool-tooltip"
      focusWithin
    >
      {children}
    </DesktopOnlyTooltip>
  )
}

ToolTooltip.propTypes = {
  id: string.isRequired,
  label: string.isRequired,
  children: node.isRequired,
}

export default memo(ToolTooltip)
